export enum UserType {
    Staff = 1,
    Parent = 2,
    Student = 3
}